export default __webpack_public_path__ + "static/media/wizard-bg-white-top.b6be0efb.svg";